// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"L7-z","dimensionLabel":"M7-z","styleChooserControlWrapper":"N7-z","styleChooserControl":"O7-z","disabled":"P7-z","giftCard":"Q7-z","styleChooserText":"R7-z"};